// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  overflow-y: auto;
}
:host::-webkit-scrollbar {
  display: none;
}

ion-item {
  cursor: pointer;
}

ion-label {
  font-weight: bold;
  text-transform: capitalize;
  padding-left: 0.5rem;
}

ion-item.mid-level-items ion-label {
  font-weight: 500;
  text-transform: capitalize;
  color: var(--medium-grey);
}

ion-item.bottom-level-items {
  --background: var(--medium-grey-tint);
}
ion-item.bottom-level-items ion-label {
  font-weight: 500;
  text-transform: capitalize;
  padding-left: 2.5rem;
  color: var(--medium-grey);
}

ion-icon.arrow-rotated {
  transform: rotate(90deg);
  transition: transform 0.3s ease;
}

.menu-seprator {
  height: 1px;
  width: 100%;
  background-color: var(--hr-line);
}

.sidemenu-main-icon {
  --icon-height: 1em;
  --icon-width: 1em;
  margin-right: 21px;
  font-size: 20px;
}

.logout-icon {
  font-size: 28px;
}

.navbar-deposit {
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu/sidemenu.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;AACI;EACI,aAAA;AACR;;AAGA;EACI,eAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,0BAAA;EACA,oBAAA;AAAJ;;AAII;EACI,gBAAA;EACA,0BAAA;EACA,yBAAA;AADR;;AAKA;EACI,qCAAA;AAFJ;AAII;EACI,gBAAA;EACA,0BAAA;EACA,oBAAA;EACA,yBAAA;AAFR;;AAMA;EACI,wBAAA;EACA,+BAAA;AAHJ;;AAMA;EACI,WAAA;EACA,WAAA;EACA,gCAAA;AAHJ;;AAMA;EACI,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAHJ;;AAMA;EACI,eAAA;AAHJ;;AAMA;EACI,gBAAA;AAHJ","sourcesContent":[":host {\n    overflow-y: auto;\n\n    &::-webkit-scrollbar {\n        display: none;\n    }\n}\n\nion-item {\n    cursor: pointer;\n}\n\nion-label {\n    font-weight: bold;\n    text-transform: capitalize;\n    padding-left: 0.5rem;\n}\n\nion-item.mid-level-items {\n    ion-label {\n        font-weight: 500;\n        text-transform: capitalize;\n        color: var(--medium-grey);\n    }\n}\n\nion-item.bottom-level-items {\n    --background: var(--medium-grey-tint);\n\n    ion-label {\n        font-weight: 500;\n        text-transform: capitalize;\n        padding-left: 2.5rem;\n        color: var(--medium-grey);\n    }\n}\n\nion-icon.arrow-rotated {\n    transform: rotate(90deg);\n    transition: transform 0.3s ease;\n}\n\n.menu-seprator {\n    height: 1px;\n    width: 100%;\n    background-color: var(--hr-line);\n}\n\n.sidemenu-main-icon {\n    --icon-height: 1em;\n    --icon-width: 1em;\n    margin-right: 21px;\n    font-size: 20px;\n}\n\n.logout-icon {\n    font-size: 28px;\n}\n\n.navbar-deposit {\n    margin-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
